/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPacman = createReactComponent("outline", "pacman", "IconPacman", [["path", { "d": "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z", "key": "svg-0" }], ["circle", { "cx": "11.5", "cy": "7.5", "r": "1", "fill": "currentColor", "key": "svg-1" }]]);

export { IconPacman as default };
//# sourceMappingURL=IconPacman.mjs.map
